import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-strength-video-modal',
  templateUrl: './strength-video-modal.component.html',
  styleUrls: ['./strength-video-modal.component.scss'],
})
export class StrengthVideoModalComponent implements OnInit {
  @Input() showModal: boolean = true;
  @Input() exercise: string = 'bicepCurl';
  @Output() hideExerciseModal: EventEmitter<any> = new EventEmitter();
  environment = environment;
  constructor() {}

  ngOnInit(): void {}

  onHide(event: any) {
    this.hideExerciseModal.emit(event);
  }
  onNoHide(event:any){
    event.stopPropagation();
  }
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.hideExerciseModal.emit(event);
  }
}
